export default __webpack_public_path__ + "static/media/login-bg-left.bd5fde2b.jpg";